module.exports = "/_next/static/images/AggregationAudienceCreation@2x-5351745d8ec03f4ca1ada27cf5209d54.png";